import type { LucideIcon } from 'lucide-react';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface StatsCardProps {
  icon: LucideIcon;
  title: string;
  value: string | number;
  change?: number;
  iconColor?: string;
}

export function StatsCard({ icon: Icon, title, value, change, iconColor = 'text-primary' }: StatsCardProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold">{value}</p>
            {change !== undefined && (
              <div
                className={cn(
                  'flex items-center gap-1 text-xs',
                  change >= 0 ? 'text-green-600' : 'text-destructive'
                )}
              >
                {change >= 0 ? (
                  <TrendingUp className="h-3 w-3" />
                ) : (
                  <TrendingDown className="h-3 w-3" />
                )}
                {Math.abs(change).toFixed(1)}% vs período anterior
              </div>
            )}
          </div>
          <Icon className={cn('h-8 w-8 opacity-80', iconColor)} />
        </div>
      </CardContent>
    </Card>
  );
}
